module.exports = __webpack_public_path__ + "img/avatar-placeholder.png";